import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".Spinner-module_loader__mRMSc {\n  color: black;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}";
var Styles = {"loader":"Spinner-module_loader__mRMSc"};
styleInject(css_248z);

export { Styles as default };
//# sourceMappingURL=Spinner.module.scss.js.map
